<app-modal #callModal [size]="ModalSize.Lg" [scrollable]="false" [customClassName]="'call-fullscreen-modal'">
  <div class="call-modal-content">
    <button *ngIf="loading" type="button" class="close-btn" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <div *ngIf="loading" class="call-loading">
      <div class="call-loading-spinner"></div>
      <span>Establishing connection...</span>
    </div>

    <app-acs-call
      #acsCall
      *ngIf="ready"
      [token]="acsToken"
      [acsUserId]="acsUserId"
      [roomId]="roomId"
      [displayName]="displayName"
      (callEnded)="onCallEnded()"
      (callError)="onCallError($any($event))">
    </app-acs-call>
  </div>
</app-modal>
